<template>
  <div class="realtime-loading__wrapper">
    <div class="realtime-loading__wrapper__container">
      <i class="icon icon-realtime-logo" />
      <div class="realtime-loading__wrapper__container__icon-wrapper">
        <i class="icon icon--loading-left" />
        <div class="realtime-loading__wrapper__container__icon-wrapper__animation">
          <div class='loading_bar'></div>
          <div class='loading_bar'></div>
          <div class='loading_bar'></div>
          <div class='loading_bar'></div>
        </div>
        <i class="icon icon--loading-right" />
      </div>
      <p v-html="$t('heatmap.realtimeLoading')"></p>
    </div>
  </div>
</template>

<script>
import { authRealTime } from '@/api/apply'

export default {
  name: 'HeatmapRealtimeLoading',
  data () {
    return {
      device: null,
      aid: null,
      originUrl: null,
      timezone: null,
      timezoneName: null
    }
  },
  created () {
    const query = this.$route.query

    if (query) {
      this.device = query.device
      this.aid = query.aid
      this.timezone = query.timezone
      this.timezoneName = query.timezoneName
      this.originUrl = query.originUrl
    }

    this.openRealtimeHeatmap()
  },
  methods: {
    openRealtimeHeatmap () {
      authRealTime(this.aid).then(data => {
        console.log(data)
        const authId = data.authId
        const userNum = data.userNum
        const query = {
          beu_aid: this.aid,
          beu_lang: this.$i18n.locale,
          beu_device: this.device,
          beu_auth_id: authId,
          beu_user_num: userNum,
          beu_timezone: this.timezone,
          beu_timezone_name: this.timezoneName,
          _beusable_realtime_view: true
        }
        if (this.originUrl.includes('?')) {
          this.originUrl += '&' + Object.keys(query).map(key => `${key}=${query[key]}`).join('&')
        } else {
          this.originUrl += '?' + Object.keys(query).map(key => `${key}=${query[key]}`).join('&')
        }
        setTimeout(() => {
          window.location.replace(`${this.originUrl}`)
        }, 1000)
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.realtime-loading {
  &__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
    z-index: 10001;
    background-image: linear-gradient(to bottom, #ffffff, #e0e0e0, #fafafa);
    isolation: isolate;

    &__container {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 490px;
      height: 370px;
      background-color: #FFFEFD;
      box-shadow: 0 30px 35px rgba(0, 0, 0, 0.15);
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      transform: translate(-50%, -50%);

      .icon-realtime-logo {
        position: absolute;
        top: 22px;
        right: 20px;
      }

      p {
        margin-top: 20px;
        color: #EC0047;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        line-height: 120%; /* 21.6px */
      }

      &__icon-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 77px;

        &__animation {
          width: 57px;
          overflow: hidden;

          .loading_bar {
            position: absolute;
            top:calc(50% - 5px);
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #ec0047;
            -webkit-animation: loading 1s ease-in-out 0s infinite;
            animation: loading 1s ease-in-out 0s infinite;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);

            &:nth-child(1) {
              -webkit-animation-delay: 0s;
              animation-delay: 0s;
            }

            &:nth-child(2) {
              -webkit-animation-delay: 0.15s;
              animation-delay: 0.15s;
            }

            &:nth-child(3) {
              -webkit-animation-delay: 0.3s;
              animation-delay: 0.3s;
            }

            &:nth-child(4) {
              -webkit-animation-delay: 0.45s;
              animation-delay: 0.45s;
            }
          }
        }
      }
    }
  }

  @keyframes loading {
    0% {
      -webkit-transform: translateX(-15px);
      transform: translateX(-15px);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      -webkit-transform: translateX(65px);
      transform: translateX(65px);
      opacity: 0;
    }
  }
  @-webkit-keyframes loading {
    0% {
      -webkit-transform: translateX(-15px);
      transform: translateX(-15px);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      -webkit-transform: translateX(65px);
      transform: translateX(65px);
      opacity: 0;
    }
  }
}
</style>
